import { createContext, useContext, useState, ReactNode } from 'react';
import { Button } from 'components/destiny/button';

interface AutofillInfo {
  label?: string;
  autofill: () => void;
}

interface AutofillContextType {
  setAutofillInfo: (info: AutofillInfo[] | null) => void;
  autofillInfo: AutofillInfo[] | null;
}

const AutofillContext = createContext<AutofillContextType>({
  setAutofillInfo: () => {},
  autofillInfo: null,
});

export const AutofillProvider = ({ children }: { children: ReactNode }) => {
  const [autofillInfo, setAutofillInfo] = useState<AutofillInfo[] | null>(null);
  const isDev = process.env.NODE_ENV === 'development';

  if (!isDev) {
    return <>{children}</>;
  }

  return (
    <AutofillContext.Provider value={{ setAutofillInfo, autofillInfo }}>
      {autofillInfo !== null && (
        <div
          style={{
            position: 'fixed',
            display: 'flex',
            flexDirection: 'row',
            gap: 16,
            bottom: '1rem',
            left: '1rem',
            zIndex: 99999,
          }}
        >
          {autofillInfo.map((info) => (
            <Button type="button" variant="secondary" onPress={info.autofill}>
              {info.label || '🪄'}
            </Button>
          ))}
        </div>
      )}
      {children}
    </AutofillContext.Provider>
  );
};

export const useAutofill = () => {
  const ctx = useContext(AutofillContext);
  const isDev = process.env.NODE_ENV === 'development';

  if (isDev && !ctx)
    throw new Error('useAutofill must be used within AutofillProvider');

  return ctx;
};
